"use client"

import Image, { ImageProps } from "next/image"
import { useState } from "react"
import { BookOpen } from "lucide-react"

interface R2ImageProps extends Omit<ImageProps, "unoptimized"> {
  fallbackIcon?: React.ReactNode
}

/**
 * Image component that automatically uses unoptimized mode for R2 images
 * to avoid Vercel Image Optimization 402 Payment Required errors
 */
export function R2Image({ src, alt, fallbackIcon, className, ...props }: R2ImageProps) {
  const [hasError, setHasError] = useState(false)
  
  // Check if the image is from R2
  const isR2Image = typeof src === 'string' && src.includes('r2.dev')
  
  // If src is not provided or error occurred, show fallback
  if (!src || hasError) {
    return (
      <div className={className || "w-full h-full bg-muted flex items-center justify-center"}>
        {fallbackIcon || <BookOpen className="h-12 w-12 text-muted-foreground" />}
      </div>
    )
  }

  return (
    <Image
      src={src}
      alt={alt || ""}
      unoptimized={isR2Image} // Bypass Vercel optimization for R2 images
      onError={() => {
        setHasError(true)
      }}
      className={className}
      {...props}
    />
  )
}

